const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

export const getRuntimeConfig = () => runtimeConfig;

export const getRuntimeValue = (key, fallback = "") =>
  runtimeConfig[key] ?? fallback;

export const runtime = {
  apiUrl: getRuntimeValue("REACT_APP_API_URL"),
  attachmentUrl: getRuntimeValue("REACT_APP_ATTACHMENT_URL"),
  assetUrl: getRuntimeValue("REACT_APP_ASSET_URL"),
  statusUrl: getRuntimeValue("REACT_APP_STATUS_URL"),
};

export default runtime;
